import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=54810664"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports